/**
 * Footer logo mover
 * Verplaatst het logo-element uit de footer-bottom strip
 * naar de top van de footer-left kolom, zodat het
 * boven 'Laten we Solvey eens verkennen' staat.
 *
 * Idempotent via data-solvey-logo-moved guard.
 */
(function () {
  'use strict';

  function moveLogo() {
    var logo = document.querySelector('[class*="footer-logo-logo_"]');
    var leftCol = document.querySelector('[class*="footer-left-"]');
    if (!logo || !leftCol) return;
    if (logo.getAttribute('data-solvey-logo-moved') === '1') return;
    if (leftCol.contains(logo)) {
      logo.setAttribute('data-solvey-logo-moved', '1');
      return;
    }
    leftCol.insertBefore(logo, leftCol.firstChild);
    logo.setAttribute('data-solvey-logo-moved', '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveLogo);
  } else {
    moveLogo();
  }

  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(moveLogo, 50);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
